import { useAuthContext } from "src/auth/AuthContext";
import FundsForm from "./FundsForm";
import { useParams } from "react-router-dom";

const FundsView = () => {
    const { user } = useAuthContext();
    const { id } = useParams();
    return <FundsForm
        fundId={parseInt(id)}
        organizationId={user.data.organizationId}
        onSubmit={(_entry) => Promise.resolve()}
        viewOnly={true}
        header='Ansicht'
    />;
};

export default FundsView;
